import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField, InputLabel, Select, MenuItem } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Navigate } from "react-router-dom";

export default class AddGallery extends Component {
  state = {
    message: "",
    notification: false,
    per_pge: 20,
    page_no: 1,
    files: [],
    form_type: "image", // "image" | "video"
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { files, form_type } = this.state;

    if (!files || files.length === 0) {
      this.setState({
        notification: true,
        message: "Please select at least one file.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    if (init() !== "success") {
      return this.setState({ redirect: true });
    }

    this.setState({ loading: true });

    const fd = new FormData();
    // new field as per updated schema/API
    fd.append("form_type", form_type); // "image" or "video"

    // backend expects multiple files under key "images"
    for (let i = 0; i < files.length; i++) {
      fd.append("images", files[i]);
    }

    axios
      .post(Constants.postUrls.addGallery, fd)
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data?.message || "Gallery added successfully!",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "", redirect: true });
        }, 3000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: err?.response?.data?.message || "Failed to add gallery",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 5000);
      });
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/gallery" />;
    }

    const { form_type } = this.state;
    const accept = form_type === "video" ? "video/*" : "image/*";

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Gallery
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Select type: Image / Video */}
                  <Grid item sm={6} xs={12}>
                    <InputLabel id="form-type-label">Media Type</InputLabel>
                    <Select
                      labelId="form-type-label"
                      name="form_type"
                      value={this.state.form_type}
                      onChange={this.handleInput}
                      fullWidth
                      required
                      style={{ width: "100%", height: "45px", color: "#fff" }}
                    >
                      <MenuItem value="image" style={{ color: "#fff" }}>
                        Image
                      </MenuItem>
                      <MenuItem value="video" style={{ color: "#fff" }}>
                        Video
                      </MenuItem>
                    </Select>
                  </Grid>

                  {/* File input (multiple) */}
                  <Grid item sm={6} xs={12}>
                    <TextField
                      type="file"
                      label={form_type === "video" ? "Select Videos" : "Select Images"}
                      name="files"
                      fullWidth
                      focused
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        multiple: true,
                        accept,
                      }}
                      onChange={(e) => {
                        this.setState({
                          files: e.target.files,
                        });
                      }}
                      style={{ width: "100%", height: "100%", top: "13px" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="VASA - Gallery"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
